/* apis */
import { subscriptions } from '@api/apis';

/* Components */
import { getLayout } from '@components/PageLayouts/Layout/Standard';
import PlansPageContainer from '@scenes/PlansPage';

/* Constants */
import { PAGE_TYPE_PLANS } from '@constants/pages';
/* Types */
import { Children } from 'types/base.types';
import { GetStaticProps } from 'next';
import { TPlansPageContainerType } from 'types/plans.types';

function PlansPage(props: TPlansPageContainerType): Children {
  return <PlansPageContainer {...props} />;
}

PlansPage.pageAttributes = { page: PAGE_TYPE_PLANS };
PlansPage.Layout = getLayout({ promo: true, footer: true });

export default PlansPage;

export const getStaticProps: GetStaticProps = async context => {
  /* Get plans data */
  const plans = await subscriptions.all().then(response => response.data);

  if (!plans || plans.errors) {
    throw new Error('No plans found');
  }

  return {
    props: {
      plans: plans.plans,
    },
    revalidate: 60 * 60, // update every hour
  };
};
